import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";

import Pagination from "../../utils/Pagination";
import SearchBy from "../../utils/SearchBy";
import { TableSortHeaders } from "../../utils/TableSortHeaders";
import ContentLoader from "../../utils/ContentLoader";
import { getLangValue } from "../../utils/tools";
import { Popover } from "antd";
import { ARTICLE_TYPE_LABELS } from "../../utils/articleTypeUtils";

const ArticlesTable = ({
    articles,
    page,
    setPage,
    totalPages,
    totalEntries,
    sort,
    order,
    setOrder,
    setSort,
    search,
    setSearch,
    fetchArticles,
    onView,
    entriesPerPage,
    setEntriesPerPage,
    onDelete
}) => {
    const viewPermissions =
        useSelector((state) => state.permission.rolePermissions) || [];

    const [loading] = useState(false);
    const navigate = useNavigate();

    const headerConfig = [
        { key: "title", label: "Article Title", sortable: false },
        { key: "article-type", label: "Article Type", sortable: false },
        { key: "status", label: "Status", sortable: false },
        { key: "action", label: "Action", sortable: false },
    ];

    if (loading) return <ContentLoader />;

    return (
        <div className="card basic-data-table text-sm overflow-x-auto">
            <div className="card-header d-flex justify-content-end align-items-center">
                <div className="d-flex align-items-center gap-3">

                    <SearchBy
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setPage(1);
                        }}
                    />

                    <button
                        className="btn btn-primary-600"
                        type="button"
                        onClick={() => navigate("/article-form")}
                    >
                        <Icon icon="fa6-regular:square-plus" />
                        Add
                    </button>
                </div>
            </div>

            <div className="card-body">
                <div className="w-full overflow-x-auto">
                    <table className="table bordered-table mb-0 text-sm w-full min-w-max">
                        <thead>
                            <tr>
                                {TableSortHeaders(
                                    headerConfig,
                                    sort,
                                    order,
                                    setSort,
                                    setOrder,
                                    setPage
                                )}
                            </tr>
                        </thead>

                        <tbody>
                            {Array.isArray(articles) && articles.length > 0 ? (
                                articles.map((item) => (
                                    <tr key={item.id}>
                                        <td>{getLangValue(item?.article_title)}</td>
                                        <td>
                                            {ARTICLE_TYPE_LABELS[item?.article_type?.name] || "-"}
                                        </td>

                                        <td>
                                            <span
                                                className={`px-24 py-4 rounded-pill fw-medium text-sm ${item.status === "draft"
                                                    ? "bg-warning-focus text-warning-600"
                                                    : item.status === "published"
                                                        ? "bg-success-focus text-success-main"
                                                        : item.status === "reject"
                                                            ? "bg-danger-focus text-danger-main px-24 py-4 rounded-pill fw-medium text-sm"
                                                            : ""
                                                    }`}
                                            >
                                                {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                            </span>
                                        </td>


                                        <td>
                                            <div className="d-flex align-items-center gap-8">

                                                {/* View */}
                                                {viewPermissions.includes("article.view") && (
                                                    <button
                                                        className="w-32-px h-32-px bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                                                        onClick={() => onView(item)}
                                                    >
                                                        <Icon icon="iconamoon:eye-light" />
                                                    </button>
                                                )}

                                                {/* Edit + Delete (3 dots menu) */}
                                                <Popover
                                                    trigger="click"
                                                    placement="bottomRight"
                                                    overlayClassName="action-popover"
                                                    content={
                                                        <div className="action-list">

                                                            {/* {viewPermissions.includes("article.edit") && ( */}
                                                            <button
                                                                onClick={() => navigate(`/article-form/${item.id}`)}
                                                                className="action-item text-success-main"
                                                            >
                                                                <Icon icon="lucide:edit" />
                                                                <span>Edit</span>
                                                            </button>
                                                            {/* )} */}

                                                            {/* {viewPermissions.includes("article.delete") && ( */}
                                                            <button
                                                                className="action-item text-danger-main"
                                                                onClick={() => onDelete(item.id)}
                                                            >
                                                                <Icon icon="mingcute:delete-2-line" />
                                                                <span>Delete</span>
                                                            </button>
                                                            {/* )} */}

                                                        </div>
                                                    }
                                                >
                                                    {/* {(viewPermissions.includes("article.edit") ||
                                                        viewPermissions.includes("article.delete")) && ( */}
                                                    <button
                                                        type="button"
                                                        className="w-32-px h-32-px bg-neutral-300 rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                                                    >
                                                        <Icon icon="mdi:dots-vertical" />
                                                    </button>
                                                    {/* )} */}
                                                </Popover>

                                            </div>
                                        </td>


                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={3} className="text-center">
                                        No Articles found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <Pagination
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    totalEntries={totalEntries}
                    entriesPerPage={entriesPerPage}
                    setEntriesPerPage={setEntriesPerPage}
                />
            </div>
        </div>
    );
};

export default ArticlesTable;